import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "placeholder",
  "use": "placeholder-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"placeholder\"><path d=\"m15 16.4 8.3 9a.87.87 0 0 0 1.3 0 1 1 0 0 0 0-1.4l-8.3-9 8.3-9a1 1 0 0 0 0-1.4.87.87 0 0 0-1.3 0l-8.3 9-8.3-9a.87.87 0 0 0-1.3 0 1 1 0 0 0 0 1.4l8.3 9-8.3 9a1 1 0 0 0 0 1.4.87.87 0 0 0 1.3 0zM0 0h30v1.1H0zM0 28.9h30V30H0z\" /><path d=\"M1.1 0v30H0V0zM30 0v30h-1.1V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol